var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navigation',{class:{"navigation--scrolled": _vm.isScrolled,
              "navigation--scrolled-perm": _vm.nav_perm_scrolled}}),_c('router-view',{on:{"makeScrolled":_vm.makeScrolled}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }